<button (click)="likeButtonClicked($event)" class="icon-action">
  <div class="like-container">
    <kp-simple-icon-animation
      [ngClass]="{ liked }"
      [options]="options"
      [iconShouldFill]="liked"
      [iconClicked]="likeClicked"
      [color]="color"></kp-simple-icon-animation>
    <span class="link-text" [ngStyle]="{ color: color }" *ngIf="likeCount > 0">
      {{ likeCount }}
    </span>
  </div>
</button>
